import React, { useRef, useEffect, useState, ChangeEvent } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import axios, { AxiosResponse } from 'axios';

import Layout from '../../components/Layout/AdminLayout/AdminLayout';
import helpers from '../../helpers/index';


import { BorrowerLoanDetails, ResponseBorrowerLoansDetail } from '../../interface/ILoanManagement'

import { Response } from '../../interface/IResponse';

import loanManagementService from './loanManagementService';

import SuccessModal from '../../components/Modal/SuccessModal';

import BorrowerLoanTable from '../../components/Table/LoanManagement/BorrowerLoanTable';


function BorrowerDetails() {


    var dispatch = useDispatch();
    const navigate = useNavigate();
    const [isReadOnly, setIsReadOnly] = useState(false);

    const [borrowerLoanDetails, setBorrowerLoanDetails] = useState<BorrowerLoanDetails>();
    const { memberId } = useParams<{ memberId: string }>();


    function getPermission() {

        var permission = helpers.getPermission();
        setIsReadOnly(permission == "ReadOnly");
    }


    async function getBorrowerLoanDetails() {
        try {



            var response: AxiosResponse<ResponseBorrowerLoansDetail> = await loanManagementService.getBorrowerLoansDetail(Number(memberId));

            console.log('ResponseLoanStatusDetails response:: ', response);
            setBorrowerLoanDetails(response.data.result);

        }
        catch (err) {

            console.log('err:: ', err);

            throw err;
        }

    }


    useEffect(function () {
        (async () => {

            document.querySelector('.loader-container')?.classList.add('loader');


            await getBorrowerLoanDetails();
            getPermission();

            document.querySelector('.loader-container')?.classList.remove('loader');
        })();
    }, [])

    return (
        <Layout>
            <div className="title-container">
                <div className="dv-title">
                    <h1>Borrower Details</h1>
                </div>
                <div className="title-btn-container vertical-flex-bottom">
                    <button
                        type="button"
                        id="btnBack"
                        onClick={() => {
                            navigate("/Admin/LoanManagement");
                        }}
                        className="btn-white-green-2 center-middle"
                    >
                        Back
                    </button>
                </div>
            </div>
            <br />
            <div className='content-container'>
                <div className='padding-container'>
                    <div className='details-container'>

                        <div className='details-inner'>
                            <div>
                                <div className='label-2'>Member Name:</div>
                                <label className='label-3' id='lblMemberName'>
                                    {borrowerLoanDetails?.firstname} {borrowerLoanDetails?.lastname}
                                </label>
                            </div>
                            <div>
                                <div className='label-2'>ID:</div>
                                <label className='label-3' id='lblId'>
                                    {borrowerLoanDetails?.membershipId}
                                </label>
                            </div>
                            <div>
                                <div className='label-2'>Email:</div>
                                <label className='label-3' id='lblEmail'>
                                    {borrowerLoanDetails?.email}
                                </label>
                            </div>
                            <div>
                                <div className='label-2'>Amount Subscribed:</div>
                                <label className='label-3' id='lblAmountSubscribed'>
                                    {helpers.formatNumber(borrowerLoanDetails?.amountSubscribe ?? 0)}
                                </label>
                            </div>

                        </div>
                    </div >
                </div >
            </div >
            <br />
            <div className='content-container'>
                <div className='table-container'>

                    <BorrowerLoanTable data={borrowerLoanDetails?.borrowerLoans ?? []} redirectUrlView='/Admin/LoanStatusDetails/'></BorrowerLoanTable>

                </div>
            </div>
        </Layout >
    );

}


export default BorrowerDetails;